<template>
  <v-container>
    <h1>{{ $t('settings.address-title')}}</h1>
    <p class="mt-2 mb-10">{{ $t('settings.address-info')}}</p>
    <v-form>
      <v-text-field
        outlined
        :label="$t('fields.firstName')"
        v-model="userdata.firstName"
      />
      <v-text-field outlined :label="$t('fields.lastName')" v-model="userdata.lastName" />
      <v-text-field
        outlined
        :label="$t('fields.mobilephone')"
        v-model="userdata.mobilephone"
        :rules="[rules.required, rules.phone]"
      />
      <v-text-field
        outlined
        :label="$t('fields.email')"
        v-model="userdata.email"
        :rules="[rules.required, rules.email]"
      />
      <v-text-field outlined :label="$t('fields.address-2')" v-model="userdata.address1" />
      <v-text-field outlined :label="$t('fields.address2')" v-model="userdata.address2" />
      <v-text-field
        outlined
        :label="$t('fields.zip')"
        v-model="userdata.zip"
        :rules="[rules.integer, rules.hasLength(5,userdata.zip)]"
      />
      <v-text-field outlined :label="$t('fields.city')" v-model="userdata.city" />
      <CountrySelector
        :outlined="true"
        :showToggle="false"
        :disabled="false"
        :label="$t('fields.country')"
        v-model="userdata.country"
      />

      <ActionButton class="mt-3" 
        @click="saveUserData" 
        actionIcon="$sl-save" 
        :isDisabled="isImitatingUser()"
      >
        {{$t('labels.save')}}
      </ActionButton>
    </v-form>
  </v-container>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import CountrySelector from '@/components/Common/CountrySelector'
import pick from 'lodash/pick'
import {RulesMixin} from '@/components/mixins'
import ActionButton from '@/components/Common/ActionButton'
const SugarDate = require('sugar/date')

// @group People
// Styled MyAddress component
export default {
  name: 'MyAddress',

  mixins: [RulesMixin],

  components: {
    CountrySelector,
    ActionButton
  },

  data: () => ({
    userdata: {},
    fields: ['firstName', 'lastName', 'email', 'address1', 'address2', 'zip', 'city', 'country', 'mobilephone']
  }),

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isImitatingUser']),
  },

  created() {
    this.setUserData()
  },

  watch: {
    currentUser: {
      handler: function() {
        this.setUserData()
      },
      deep: true
    }
  },

  methods: {
    ...mapActions('currentuser', ['updateCurrentUserData']),

    setUserData() {
      this.userdata = pick(this.currentUser, this.fields)
    },
     /**
     * @vuese
     * Used to save user data
    * @arg The argument is an object representing user data
     */
    saveUserData() {
      API.updatePerson({data: this.userdata})
        .then(res => {
          //Set a cookie, the confirm phone modal in LoggedIn.vue will not show for 6 months
          this.$cookies.set("confirmPhoneDate" + this.currentUser.id, new SugarDate.Date().format("{yyyy}-{MM}-{dd}").raw, '6m')

          this.$events.fire('showInfo', this.$t('success.saved'))
            /**
           * @vuese
           * Used to Update currentuser tc in local store  with now date 
           * @arg The argument is an object representing user data
           */
          return this.updateCurrentUserData(this.userdata)
        })
        .catch(error => {
          this.$events.fire('showError', this.$t('errors.save-failure'))
          console.log('There was an error:', error)
        })
    }
  }
}
</script>

<style>
</style>